// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__N7t6V","contacts-list":"style_contacts-list__20Yc_","warning":"style_warning__3mGhB","warning-icon":"style_warning-icon__3lrr_"};